<div class="pcs-container">
  <div class="pcs-header">
    <h3 class="pcs-title">Lender Organizations</h3>
    @if (isAdmin()) {
      <div class="card-actions">
        <button
          (click)="goToUpdate()"
          mat-flat-button
          color="primary"
          type="button"
          ><mat-icon>add</mat-icon> Create</button>
        </div>
      }
    </div>
<div class="search-filter-container">
  <app-search-sort
    [searchControl]="searchControl"
    [sortForm]="sortForm"
    [sortOptions]="sortOptions"
    (apply)="setSortField()"
    (close)="resetSortField()"
  ></app-search-sort>

  @if (isAdmin() || isSystemUser()) {
    <div class="show-all-container">
      <mat-checkbox
        name="showAll"
        [(ngModel)]="showAll"
        (change)="onShowAllChange()"
        color="primary"
      >
        Show All
      </mat-checkbox>
    </div>
  }
</div>
    <div class="pro-card column">
      <app-ag-grid-wrapper
        [data]="rowData"
        [columns]="columnDefs"
        [getRowStyle]="getRowStyle"
        (ready)="onGridReady($event)"
        />
        <mat-paginator
          #paginator
          [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
          [length]="totalCount"
          [pageIndex]="currentPage"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSettings.pageSizeOptions"
          (page)="handlePageEvent($event)"
          aria-label="Select page"
          >
        </mat-paginator>
      </div>

    </div>

